import { Common } from '@crops';
import { atom } from 'recoil';

const CommonDataState = atom<Common.TCommonData>({
  key: 'CommonDataState',
  default: {
    ctpv : [], // 시 리스트
    sgg: [], //시군구 리스트
    emd: [], //읍면동 리스트
    legend: [], // 조회 창의 작물 조건 목록 from api
    tillageCode: [], //경작 비경작 코드
    cropsCode: [], // 재배작물신고리스트
    cropsRegKind: [], //
  },
});

export { CommonDataState };
